<template>
<div>
    <section-header />

      <section class="about-section-two">
        <div class="auto-container">
            <div class="inner-container">
                <div class="row clearfix">
                    <!--Column-->
                      <div class="content-column col-md-6 col-sm-12 col-xs-12">
                        <div class="inner-content">
                            <div class="dark-text">{{ $t('view.services-biotech-pharma.title-1') }}</div>
                            <div class="text">
                                <p>{{ $t('view.services-biotech-pharma.text-1') }}</p>
                                  <ul class="list-style-three">
                                    <li>{{ $t('view.services-biotech-pharma.list-1.item-1') }}</li>
                                    <li>{{ $t('view.services-biotech-pharma.list-1.item-2') }}</li>
                                    <li>{{ $t('view.services-biotech-pharma.list-1.item-3') }}</li>
                                  </ul>
                            </div>
                          </div>
                      </div>
                      <!--Column-->
                      <div class="image-column col-md-6 col-sm-12 col-xs-12">
                        <div class="image">
                            <img src="images/resource/bcom/biotech.jpg" alt="" />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>

        <section class="featured-section-two">
          <div class="auto-container">
              <div class="row clearfix">

                    <!--Featured Block Two-->
                    <div class="featured-block-two col-lg-4 col-md-6 col-sm-6 col-xs-12">
                      <div class="inner-box">
                          <div class="icon-box">
                              <span class="icon flaticon-medical-kit-bag"></span>
                            </div>
                            <h3>{{ $t('view.services-biotech-pharma.title-2') }}</h3>
                            <div class="text">{{ $t('view.services-biotech-pharma.text-2') }}</div>
                        </div>
                    </div>

                    <!--Featured Block Two-->
                    <div class="featured-block-two col-lg-4 col-md-6 col-sm-6 col-xs-12">
                      <div class="inner-box">
                          <div class="icon-box">
                              <span class="icon flaticon-book-1"></span>
                            </div>
                            <h3>{{ $t('view.services-biotech-pharma.title-3') }}</h3>
                            <div class="text">{{ $t('view.services-biotech-pharma.text-3') }}</div>
                        </div>
                    </div>

                  <!--Featured Block Two-->
                    <div class="featured-block-two col-lg-4 col-md-6 col-sm-6 col-xs-12">
                      <div class="inner-box">
                          <div class="icon-box">
                              <span class="icon flaticon-checked-box"></span>
                            </div>
                            <h3>{{ $t('view.services-biotech-pharma.title-4') }}</h3>
                            <div class="text">{{ $t('view.services-biotech-pharma.text-4') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


      <section class="press-section">
            <div class="auto-container">
              </div>
          </section>

</div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue';

export default {
  name: 'ServicesBiotechPharma',
  components: {
    SectionHeader
  },
  data() {
    return {
      content: ''
    };
  },
  mounted() {

  }
};
</script>